import { useEffect } from 'react';
import { gsap } from 'gsap';

const AnimatedLogoColored = () => {
  useEffect(() => {
    const paths = document.querySelectorAll('#animated-logo path');
    const tl = gsap.timeline({ repeat: -1 });

    // First set all paths to initial state
    gsap.set(paths, {
      stroke: '#ffffff33',
      strokeWidth: 1,
      scale: 1,
      transformOrigin: 'center center',
    });

    // Create animation timeline
    paths.forEach((_, index) => {
      // Check if it's not the last path
      if (index < paths.length - 1) {
        tl.to(paths[index], {
          duration: 0.1,
          scale: 1.1,
          fill: '#111',
        }).to(paths[index], {
          duration: 0.1,
          scale: 1,
          fill: 'none',
        });

        // If it's not the last path, overlap with next path's animation
        if (index < paths.length - 2) {
          tl.to(paths[index + 1], {
            duration: 0.1,
            scale: 1.1,
            fill: '#111',
          });
        }
      } else {
        // For the last path, only animate the fill without scaling
        tl.to(paths[index], {
          duration: 0.1,
          // fill: '#111',
        }).to(paths[index], {
          duration: 0.1,
          fill: 'none',
        });
      }
    });
  }, []);
  return (
    <svg
      id='animated-logo'
      width='140'
      height='140'
      viewBox='0 0 140 140'
      xmlns='http://www.w3.org/2000/svg'
      className='relative z-20'
    >
      <g clipPath='url(#clip0_3629_34782)'>
        <path
          // border
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38.1189 56.2193C36.8141 59.246 35.9264 62.493 35.5332 65.8891H0.00589929C0.565947 56.0704 3.15169 46.7938 7.34609 38.4646L38.1189 56.2193Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M49.2484 42.1347C46.5614 44.1426 44.1722 46.5258 42.1644 49.2128L11.3915 31.4581C16.6465 23.4804 23.4921 16.6407 31.4818 11.3858L49.2484 42.1347Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M65.9245 0V35.4975C62.5225 35.8907 59.2754 36.7785 56.2488 38.0832L38.4822 7.33424C46.8174 3.13984 56.0998 0.560048 65.9245 0Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M101.493 7.33424L83.7269 38.0832C80.7002 36.7785 77.4472 35.8907 74.0512 35.4975V0C83.8758 0.560048 93.1583 3.13984 101.493 7.33424Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M128.597 31.4581L97.8238 49.2128C95.8159 46.5258 93.4327 44.1426 90.7397 42.1347L108.506 11.3858C116.49 16.6407 123.336 23.4804 128.597 31.4581Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M139.982 65.8891H104.455C104.062 62.493 103.174 59.246 101.869 56.2193L132.642 38.4646C136.836 46.7938 139.422 56.0704 139.982 65.8891Z'
        />
        <path
          stroke='#ffffff33'
          strokeWidth='2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M140 73.9919C137.903 110.8 107.362 140 70 140C32.6377 140 2.10316 110.8 0 73.9919H35.5273C37.5351 91.2342 52.2036 104.622 70 104.622C87.7964 104.622 102.465 91.2402 104.473 73.9919H140Z'
        />
      </g>
      <defs>
        <clipPath id='clip0_3629_34782'>
          <rect width='140' height='140' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AnimatedLogoColored;
